import { Breadcrumbs } from "./Breadcrumbs";
import { Reveal } from "./Reveal";
import { Overline } from "./SectionHeading";

// Hero used on inner pages: image banner + breadcrumb + title + subtitle.
export const PageHero = ({ overline, title, subtitle, image, breadcrumbs = [], meta }) => (
  <section className="relative" data-testid="page-hero">
    <div className="relative h-[44vh] min-h-[340px] w-full overflow-hidden md:h-[52vh]">
      <img src={image} alt={title} className="h-full w-full object-cover animate-kenburns" />
      <div className="absolute inset-0 bg-gradient-to-t from-charcoal/90 via-charcoal/45 to-charcoal/20" />
      <div className="absolute inset-x-0 bottom-0">
        <div className="container-wide pb-10 md:pb-12">
          <Reveal>
            {overline && <Overline className="mb-3 text-gold-light">{overline}</Overline>}
            <h1 className="max-w-4xl font-serif text-4xl font-medium leading-[1.05] tracking-tight text-white md:text-5xl lg:text-6xl text-balance">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-4 max-w-2xl text-base font-light text-white/80 md:text-lg">
                {subtitle}
              </p>
            )}
            {meta && <div className="mt-5">{meta}</div>}
          </Reveal>
        </div>
      </div>
    </div>
    <div className="border-b border-stone-line bg-white/60">
      <div className="container-wide py-3.5">
        <Breadcrumbs items={breadcrumbs} />
      </div>
    </div>
  </section>
);

export default PageHero;
